import {createApp} from 'vue'
import LotteryForm from './LotteryForm'

const el = '.kb-component--lottery-form'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((LotteryFormDOM)=>{
            const props = {
                lotteryRounds: JSON.parse(LotteryFormDOM.dataset.lotteryDropdownOptions)
            }
            const component = createApp(LotteryForm, props).use(Store)
            component.mount(LotteryFormDOM)
        })
    }
}